// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';

// const ActiveBots = ({ trades, onCloseTrade }) => {
//   const [sortBy, setSortBy] = useState('timestamp');
//   const [sortOrder, setSortOrder] = useState('desc');

//   const handleSort = (field) => {
//     if (sortBy === field) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(field);
//       setSortOrder('desc');
//     }
//   };

//   const sortedTrades = [...trades]?.sort((a, b) => {
//     let aValue = a?.[sortBy];
//     let bValue = b?.[sortBy];

//     if (typeof aValue === 'string') {
//       aValue = aValue?.toLowerCase();
//       bValue = bValue?.toLowerCase();
//     }

//     if (sortOrder === 'asc') {
//       return aValue > bValue ? 1 : -1;
//     } else {
//       return aValue < bValue ? 1 : -1;
//     }
//   });

//   const formatPnL = (pnl) => {
//     const isPositive = pnl >= 0;
//     return {
//       value: `${isPositive ? '+' : ''}$${Math.abs(pnl)?.toLocaleString()}`,
//       className: isPositive ? 'text-success' : 'text-error'
//     };
//   };

//   return (
//     <div className="bg-card border border-border rounded-2xl trading-shadow">
//       <div className="p-6 border-b border-border-secondary">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
//               <Icon name="Activity" size={16} className="text-primary" />
//             </div>
//             <h3 className="text-lg font-semibold text-foreground">Active Paper Trades</h3>
//           </div>
//           <div className="flex items-center space-x-2">
//             <span className="text-sm text-muted-foreground">{trades?.length} positions</span>
//           </div>
//         </div>
//       </div>
//       <div className="overflow-x-auto">
//         <table className="w-full">
//           <thead className="bg-muted/50">
//             <tr>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('pair')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>Pair</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('side')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>Side</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('size')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>Size</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('entryPrice')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>Entry Price</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('currentPrice')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>Current Price</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th
//                 className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground trading-transition"
//                 onClick={() => handleSort('pnl')}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>P&L</span>
//                   <Icon name="ArrowUpDown" size={12} />
//                 </div>
//               </th>
//               <th className="text-left p-4 text-sm font-medium text-muted-foreground">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {sortedTrades?.map((trade) => {
//               const pnlFormatted = formatPnL(trade?.pnl);
//               const pnlPercentage = ((trade?.currentPrice - trade?.entryPrice) / trade?.entryPrice) * 100;

//               return (
//                 <tr key={trade?.id} className="border-b border-border-secondary hover:bg-muted/30 trading-transition">
//                   <td className="p-4">
//                     <div className="flex items-center space-x-2">
//                       <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
//                         <span className="text-xs font-medium text-primary">
//                           {trade?.pair?.split('/')?.[0]?.slice(0, 2)}
//                         </span>
//                       </div>
//                       <span className="font-medium text-foreground">{trade?.pair}</span>
//                     </div>
//                   </td>
//                   <td className="p-4">
//                     <span className={`px-2 py-1 rounded-lg text-xs font-medium ${
//                       trade?.side === 'LONG' ?'bg-success/10 text-success' :'bg-error/10 text-error'
//                     }`}>
//                       {trade?.side}
//                     </span>
//                   </td>
//                   <td className="p-4">
//                     <span className="text-foreground font-medium">{trade?.size}</span>
//                   </td>
//                   <td className="p-4">
//                     <span className="text-foreground">${trade?.entryPrice?.toLocaleString()}</span>
//                   </td>
//                   <td className="p-4">
//                     <div className="flex items-center space-x-2">
//                       <span className="text-foreground">${trade?.currentPrice?.toLocaleString()}</span>
//                       <span className={`text-xs ${
//                         pnlPercentage >= 0 ? 'text-success' : 'text-error'
//                       }`}>
//                         ({pnlPercentage >= 0 ? '+' : ''}{pnlPercentage?.toFixed(2)}%)
//                       </span>
//                     </div>
//                   </td>
//                   <td className="p-4">
//                     <span className={`font-semibold ${pnlFormatted?.className}`}>
//                       {pnlFormatted?.value}
//                     </span>
//                   </td>
//                   <td className="p-4">
//                     <button
//                       onClick={() => onCloseTrade(trade?.id)}
//                       className="px-3 py-1 bg-error/10 hover:bg-error/20 text-error rounded-lg text-sm font-medium trading-transition"
//                     >
//                       Close
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//       {trades?.length === 0 && (
//         <div className="p-12 text-center">
//           <div className="w-16 h-16 bg-muted/50 rounded-2xl flex items-center justify-center mx-auto mb-4">
//             <Icon name="TrendingUp" size={24} className="text-muted-foreground" />
//           </div>
//           <h3 className="text-lg font-semibold text-foreground mb-2">No Active Trades</h3>
//           <p className="text-muted-foreground">Start a paper trading simulation to see your positions here.</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ActiveBots;

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import apiUtils from "utils/apiutils";

import PaperActiveBots from "./PaperActiveBots";
import Icon from "../../../components/AppIcon";

function ActiveBots({ strategyName, botname }) {
  const [bots, setBots] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBots = async () => {
    setIsLoading(true);
    const payloads = {
      page_no: pageNo,
      page_size: pageSize,
      bot_name: botname,
      strategy_name: strategyName?.toUpperCase(),
      trade_type: "PAPER",
    };

    try {
      const resp = await apiUtils.post("/bot/view_bot", payloads, {
        showToast: false,
      });
      if (resp?.Success) {
        setBots(resp.Success);
      } else {
        setBots([]);
      }
    } catch (e) {
      console.error("Error fetching bots:", e);
      setBots([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTotalPages = async () => {
    const payloads = {
      page_no: 1,
      page_size: pageSize,
      bot_name: botname,
      strategy_name: strategyName?.toUpperCase(),
      trade_type: "PAPER",
    };

    try {
      const resp = await apiUtils.post("/bot/total_view_bot", payloads, {
        showToast: false,
      });
      if (resp?.Success != null) {
        setTotalPages(resp.Success);
      } else {
        setTotalPages(0);
      }
    } catch (e) {
      console.error("Error fetching total pages:", e);
      setTotalPages(0);
    }
  };

  useEffect(() => {
    fetchBots();
  }, [strategyName, botname, pageNo, pageSize]);

  useEffect(() => {
    fetchTotalPages();
  }, [pageSize]);

  useEffect(() => {
    if (totalPages > 0 && pageNo > totalPages) {
      setPageNo(totalPages);
    } else if (totalPages === 0) {
      setPageNo(1);
    }
  }, [totalPages]);

  const pageSizeOptions = [10, 20, 50, 100];

  return (
    <div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-card border border-border rounded-xl mb-6 overflow-hidden"
      >
        <h2 className="text-xl font-bold m-4">Active Bots</h2>
        <div className="flex border-b border-border-secondary"></div>

        <PaperActiveBots
          bots={bots}
          isLoading={isLoading}
          pageNo={pageNo}
          pageSize={pageSize}
          strategyName={strategyName}
          fetchBots={fetchBots}
          fetchTotalPages={fetchTotalPages}
        />

        {totalPages > 0 && (
          <div className="px-4 py-3 border-t border-border-secondary">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
              <div className="order-2 md:order-1">
                Page {pageNo} of {totalPages} ({bots.length} bots on this page)
              </div>

              <div className="flex items-center gap-3 order-1 md:order-2">
                <button
                  onClick={() => setPageNo(1)}
                  disabled={isLoading || pageNo === 1}
                  className="p-2 rounded-lg bg-card border border-border hover:bg-primary/5 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <Icon name="ChevronsLeft" size={14} />
                </button>
                <button
                  onClick={() => setPageNo(pageNo - 1)}
                  disabled={isLoading || pageNo === 1}
                  className="p-2 rounded-lg bg-card border border-border hover:bg-primary/5 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <Icon name="ChevronLeft" size={14} />
                </button>

                <div className="flex items-center gap-2">
                  <span>Page</span>
                  <input
                    type="number"
                    value={pageNo}
                    onChange={(e) => {
                      let p = parseInt(e.target.value) || 1;
                      p = Math.max(1, Math.min(p, totalPages));
                      setPageNo(p);
                    }}
                    min={1}
                    max={totalPages}
                    className="w-14 px-2 py-1 text-center bg-card border border-border rounded focus:border-primary focus:outline-none"
                    disabled={isLoading}
                  />
                  <span>of {totalPages}</span>
                </div>

                <button
                  onClick={() => setPageNo(pageNo + 1)}
                  disabled={isLoading || pageNo >= totalPages}
                  className="p-2 rounded-lg bg-card border border-border hover:bg-primary/5 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <Icon name="ChevronRight" size={14} />
                </button>
                <button
                  onClick={() => setPageNo(totalPages)}
                  disabled={isLoading || pageNo === totalPages}
                  className="p-2 rounded-lg bg-card border border-border hover:bg-primary/5 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <Icon name="ChevronsRight" size={14} />
                </button>
              </div>

              <div className="flex items-center gap-2 order-3">
                <span>Rows per page:</span>
                <select
                  value={pageSize}
                  onChange={(e) => {
                    const newSize = Number(e.target.value);
                    setPageSize(newSize);
                    setPageNo(1);
                  }}
                  disabled={isLoading}
                  className="bg-card border border-border rounded px-3 py-1.5 focus:border-primary focus:outline-none cursor-pointer"
                >
                  {pageSizeOptions.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default ActiveBots;
